/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface UserProfileUpdateRequest {
  /** @format int64 */
  avatarId?: number;
  nickname: string;
  description?: string;
}

export interface IDOnlyResponse {
  /** @format int64 */
  id?: number;
}

export interface AgentThreadUpdateDto {
  title?: string;
  imageUrl?: string;
}

export interface AgentThreadVo {
  id?: string;
  autoMode?: boolean;
  title?: string;
  imageUrl?: string;
  /**
   * 分享类型: 0=PRIVATE(私有), 1=SHARED(共享), 2=FEATURESHARED(社区精选)
   * @format int32
   */
  shareType?: number;
  /** 线程类型: interactive, streaming, one_shot */
  type?: string;
  options?: object;
  tags?: Record<string, object>;
  latestResultVideoUrl?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  status?: AgentThreadVoStatus;
  enableCheckpoint?: boolean;
  /**
   * 当前用户对该 thread 的投票：1=点赞，-1=点踩，0=取消，null=未投票
   * @format int32
   */
  voting?: number;
  owner?: boolean;
}

export interface UpdateArtifactsRequest {
  artifact_type?: UpdateArtifactsRequestArtifactType;
  data?: object;
}

export interface ApplyArtifactFileVersionRequest {
  /** @format int32 */
  index?: number;
  artifact_type?: ApplyArtifactFileVersionRequestArtifactType;
  file_type?: ApplyArtifactFileVersionRequestFileType;
  file_path?: string;
}

export interface EmptySuccessResponse {
  message?: string;
}

export interface SystemPromptUpdateRequest {
  content: string;
}

export interface UserEmailCodeSendRequest {
  email: string;
  captchaVerifyParam?: string;
}

export interface BindReferralCodeRequest {
  code: string;
}

export interface UserEmailCodeVerifyRequest {
  email: string;
  /**
   * @minLength 6
   * @maxLength 6
   */
  code: string;
  referralCode?: string;
}

export interface UserProfile {
  /** @format int64 */
  id?: number;
  email?: string;
  nickname?: string;
  description?: string;
  emailVerified?: boolean;
  newUser?: boolean;
  avatarUrl?: string;
}

export interface MessageVoteRequest {
  /** @format int32 */
  value?: number;
}

export interface AgentToolCallRequest {
  init_args?: Record<string, object>;
  call_args?: Record<string, object>;
  /** @format int32 */
  num_results?: number;
}

export interface ThreadReactiveVO {
  id?: string;
  userInput?: string;
  type?: string;
  audioScript?: string;
  requestId?: string;
  userId?: string;
  context?: Record<string, object>;
  templateId?: string;
  templateContent?: string;
  status?: string;
  projectId?: string;
  workingDir?: string;
  workflowCode?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  files?: UploadedFile[];
}

export interface UploadedFile {
  filename?: string;
  media_type?: string;
  /** @format int64 */
  size?: number;
  file_path?: string;
}

export interface AgentThreadMessageQueueResponse {
  status?: string;
}

export interface AgentThreadControlSignalDto {
  signal?: AgentThreadControlSignalDtoSignal;
}

export interface AgentThreadAutoModeDto {
  autoMode?: boolean;
}

export interface UploadArtifactFileResponse {
  file_path?: string;
  identity?: string;
}

export interface ReportCreateRequest {
  /** @format int64 */
  targetId: number;
  targetType: string;
  tags: string[];
  comment?: string;
}

export interface UseRedemptionCodeRequest {
  code: string;
}

export interface UseRedemptionCodeVo {
  success?: boolean;
  message?: string;
  planCode?: string;
}

export interface CustomApiPackageRequestVo {
  company?: string;
  business?: string;
  phone?: string;
  detail: string;
}

export interface ApiKeyRequest {
  name: string;
}

export interface ApiKey {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  /** @format int64 */
  orgId?: number;
  name?: string;
  value?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface SubscribeRequest {
  type: SubscribeRequestType;
  data: string;
}

export interface SubscriptionView {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  type?: SubscriptionViewType;
  data?: string;
}

export interface VerifyPermissionRequest {
  function?: VerifyPermissionRequestFunction;
}

export interface InvitationCodeResponse {
  success?: boolean;
  message?: string;
  invitationCodes?: Record<string, string[]>;
}

export interface UseInvitationCodeRequest {
  code?: string;
}

export interface UnbindInvitationCodeRequest {
  /** @format int64 */
  userId?: number;
  invitationCode?: string;
}

export interface GenerateInvitationCodeRequest {
  codeIdentifier?: string;
  functions?: GenerateInvitationCodeRequestFunctions[];
  /** @format int32 */
  maxUsageCount?: number;
  /** @format int32 */
  codeCount?: number;
  description?: string;
  /** @format int64 */
  effectiveTime?: number;
  /** @format int64 */
  expireTime?: number;
}

/** 问卷/反馈提交请求：type 为反馈类型，content 为 JSON 字符串，可包含 subType（如 ProductFeedback、ThreadFeedback）等字段 */
export interface FeedbackSubmitRequest {
  /** 反馈类型 */
  type: FeedbackSubmitRequestType;
  /**
   * 反馈内容，前端传入 JSON 字符串；当 type 为 feedback 时，JSON 中可包含 subType（ProductFeedback / ThreadFeedback）等字段
   * @example "{"subType":"ProductFeedback","detail":"..."}"
   */
  content: string;
}

export interface SetConfigRequest {
  key?: string;
  value?: string;
  configServiceEnum?: SetConfigRequestConfigServiceEnum;
}

export interface ConfigItem {
  key?: string;
  value?: string;
}

export interface ConfigResponse {
  success?: boolean;
  values?: ConfigItem[];
}

export interface GetConfigRequest {
  keys?: string[];
  configServiceEnum?: GetConfigRequestConfigServiceEnum;
}

export interface DeleteConfigRequest {
  key?: string;
  configServiceEnum?: DeleteConfigRequestConfigServiceEnum;
}

export interface CheckAuthVo {
  result?: boolean;
}

export interface AssetView {
  /** @format int64 */
  id?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format float */
  duration?: number;
  url?: string;
  previewUrl?: string;
  mediaType?: AssetViewMediaType;
  source?: AssetViewSource;
  /** @format int64 */
  generationId?: number;
  filename?: string;
  favorite?: boolean;
  /** @format int64 */
  voiceId?: number;
}

export interface ModerateVideoCallbackRequest {
  checksum?: string;
  content?: string;
}

export interface MultipartUploadInitRequest {
  fileName?: string;
  contentType?: string;
  /** @format int64 */
  fileSize?: number;
}

export interface MultipartUploadVO {
  uploadId?: string;
  objectKey?: string;
  /** @format int32 */
  partCount?: number;
  signedUrls?: string[];
  downloadUrl?: string;
}

export interface MultipartUploadCompleteRequest {
  uploadId?: string;
  objectKey?: string;
  parts?: MultipartUploadPart[];
}

export interface MultipartUploadPart {
  /** @format int32 */
  part_number?: number;
  etag?: string;
}

export interface AgentEventRequest {
  name: AgentEventRequestName;
  payload: Record<string, object>;
  thread_id: string;
}

export interface AdminBanUserRequest {
  email: string;
}

export interface GeneralResponse {
  success?: boolean;
  message?: string;
  data?: object;
}

export interface AddSuperAdminRequest {
  email: string;
}

export interface GenerateAccessTokenRequest {
  email: string;
}

export interface GenerateAccessTokenResponse {
  email?: string;
  accessToken?: string;
  /** @format int64 */
  userId?: number;
}

export interface BatchGenerateRedemptionCodeRequest {
  batchNo: string;
  planCode: string;
  /** @format date-time */
  expireAt: string;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  count: number;
}

export interface BatchGenerateRedemptionCodeResponse {
  codes?: string[];
  batchNo?: string;
  /** @format int32 */
  count?: number;
}

export interface SubscriptionBonusPromotion {
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  memberBonusMap?: Record<string, number>;
}

export interface CreditPackagePromotion {
  /** @format date-time */
  startTime?: string;
  /** @format date-time */
  endTime?: string;
  /** @format double */
  bonusMultiplier?: number;
}

export interface GrantMembershipRequest {
  /** @format int64 */
  userId?: number;
  email?: string;
  planCode: string;
}

export interface GrantMembershipResultResponse {
  success?: boolean;
  message?: string;
  /** @format int64 */
  orderId?: number;
  /** @format int64 */
  userId?: number;
  planCode?: string;
  currentPlanCode?: string;
  currentPlanExpireTime?: string;
  grantTime?: string;
}

/** 反馈修改请求，仅传需要更新的字段 */
export interface FeedbackUpdateRequest {
  /** 流程状态：1待分析，2待人工处理，3已处理 */
  status?: FeedbackUpdateRequestStatus;
  /** 邮件回复内容 */
  emailContent?: string;
  /** 负责人 */
  owner?: string;
  /** 问题类型：engineering_bug(工程BUG)，effect_issue(效果问题)，product_issue(产品问题) */
  problemType?: FeedbackUpdateRequestProblemType;
  /** 推荐处理方式 */
  recommendHandle?: string;
}

export interface ButtonComponent {
  label: string;
  style: ButtonComponentStyle;
  customId?: string;
  url?: string;
  emoji?: string;
  disabled?: boolean;
}

export interface SendDiscordMessageRequest {
  channelId: string;
  embedJson: string;
  buttons?: ButtonComponent[];
}

export interface SendDiscordMessageResponse {
  messageId?: string;
  status?: string;
}

export interface IssueUserCreditRequest {
  userIds?: string[];
  emails?: string[];
  /** @format int32 */
  amount: number;
  creditType: string;
}

export interface IssueOrgCreditRequest {
  orgIds: string[];
  /** @format int32 */
  amount: number;
  creditType: string;
}

export interface DeductCreditRequest {
  /** @format int64 */
  userId?: number;
  /** @format int64 */
  orgId?: number;
  productName?: string;
  units: string;
  reasonSubType: string;
  groupId?: string;
}

export interface ConfirmDeductionRequest {
  /** @format int64 */
  transactionId: number;
  units?: string;
}

export interface CancelDeductionRequest {
  /** @format int64 */
  transactionId: number;
}

export interface UpdateThreadRequest {
  imageUrl?: string;
  tags?: Record<string, object>;
  latestResultVideoUrl?: string;
  options?: Record<string, object>;
}

export interface ReferralLinkResponse {
  code?: string;
}

export interface ListResponseByPageAgentThreadVo {
  list?: AgentThreadVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ToolInfoDto {
  type?: string;
  options?: Record<string, object>;
  init_args?: Record<string, object>;
  call_args?: Record<string, object>;
  /** @format int32 */
  num_results?: number;
}

export interface AgentThreadTask {
  id?: string;
  task_type?: string;
  thread_id?: string;
  data?: Record<string, object>;
  status?: AgentThreadTaskStatus;
  message?: string;
  /** @format date-time */
  create_time?: string;
  /** @format date-time */
  update_time?: string;
}

export interface AgentThreadShareVo {
  id?: string;
  title?: string;
  imageUrl?: string;
  /**
   * 分享类型: 0=PRIVATE(私有), 1=SHARED(共享), 2=FEATURESHARED(社区精选)
   * @format int32
   */
  shareType?: number;
  prompt?: string;
  files?: UploadFile[];
  resultPath?: string;
  owner?: boolean;
}

export interface UploadFile {
  filename?: string;
  mediaType?: string;
  /** @format int32 */
  size?: number;
  filePath?: string;
}

export interface AgentThreadMessageDetail {
  id?: string;
  threadId?: string;
  type?: AgentThreadMessageDetailType;
  content?: Record<string, object>;
  status?: AgentThreadMessageDetailStatus;
  commitHash?: string;
  /** @format double */
  timestamp?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
  /** @format int32 */
  voting?: number;
}

export interface ListResponseByPageAgentThreadMessageDetail {
  list?: AgentThreadMessageDetail[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface SseEmitter {
  /** @format int64 */
  timeout?: number;
}

export type StreamingResponseBody = object;

/** Thread credits consumption summary grouped by reason sub type */
export interface ThreadCreditsVO {
  /** Thread ID */
  threadId?: string;
  /**
   * Total credits consumed in this thread
   * @format int32
   */
  totalCredits?: number;
  /** Credits grouped by reason sub type (e.g., VIDEO_GENERATION, IMAGE_GENERATION) */
  creditsByReasonSubType?: Record<string, number>;
}

export interface SystemConfigView {
  disableEmailLogin?: boolean;
}

export interface ReasonCategoryVo {
  name?: string;
  tags?: TagVo[];
}

export interface ReportTagsVo {
  categories?: ReasonCategoryVo[];
}

export interface TagVo {
  code?: string;
  description?: string;
}

/** Active promotion information */
export interface ActivePromotionVo {
  /** Credit package promotion information */
  creditPackagePromotion?: CreditPackagePromotionVo;
  /** Subscription bonus promotion information */
  subscriptionBonusPromotion?: SubscriptionBonusPromotionVo;
}

/** Credit package promotion information */
export interface CreditPackagePromotionVo {
  /**
   * Promotion start time (UTC)
   * @format date-time
   */
  startTime?: string;
  /**
   * Promotion end time (UTC)
   * @format date-time
   */
  endTime?: string;
  /**
   * Bonus multiplier (e.g., 0.5 means 50% extra credits)
   * @format double
   */
  bonusMultiplier?: number;
}

/** Subscription bonus promotion information */
export interface SubscriptionBonusPromotionVo {
  /**
   * Promotion start time (UTC)
   * @format date-time
   */
  startTime?: string;
  /**
   * Promotion end time (UTC)
   * @format date-time
   */
  endTime?: string;
  /** Bonus credits for each membership tier (key: memberCode like 'pro', 'studio'; value: bonus credits) */
  memberBonusMap?: Record<string, number>;
}

export interface ListResponseByPagePlatformOrderVo {
  list?: PlatformOrderVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface PlatformOrderVo {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  amount?: number;
  payer?: UserProfile;
  /** @format int64 */
  creditAmount?: number;
  /** @format date-time */
  createTime?: string;
}

export interface CreditDetailVo {
  creditAmount?: string;
  creditType?: string;
  expireTime?: string;
}

export interface PlatformOrganizationCreditVo {
  creditAmount?: string;
  creditDetailList?: CreditDetailVo[];
  usage?: UserCreditDailyUsageDO[];
}

export interface UserCreditDailyUsageDO {
  /** @format int32 */
  amount?: number;
  date?: string;
}

export interface ListResponseByPageUserCreditTransactionVo {
  list?: UserCreditTransactionVo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface UserCreditTransactionVo {
  /** @format int32 */
  amount?: number;
  createTime?: string;
  direction?: string;
  reasonType?: string;
  reasonSubType?: string;
  productName?: string;
}

export interface PlatformCreditPackage {
  id?: string;
  price?: string;
  /** @format int32 */
  amount?: number;
  outCode?: string;
  currency?: string;
  status?: PlatformCreditPackageStatus;
}

export interface ApiKeyVo {
  /** @format int64 */
  id?: number;
  name?: string;
  /** @format date-time */
  createTime?: string;
}

export interface FeatureVO {
  description?: string;
  tooltip?: string;
}

export interface PlanPageVo {
  planList?: PlanVo[];
  yearlyDiscount?: string;
  /** @format int32 */
  freeCreditAmount?: number;
}

export interface PlanVo {
  price?: string;
  originalPrice?: string;
  planCode?: string;
  currency?: string;
  priceId?: string;
  intervalType?: string;
  memberShipName?: string;
  memberCode?: string;
  description?: string;
  tooltipForCredit?: string;
  /** @format int32 */
  planGrade?: number;
  /** @format int32 */
  creditAmount?: number;
  featureList?: FeatureVO[];
  /** @format int32 */
  firstSubscriptionBonus?: number;
  descriptionForCredit?: string;
  recommend?: boolean;
}

export interface UserPlanVo {
  planCode?: string;
  price?: string;
  originalPrice?: string;
  currency?: string;
  memberShipName?: string;
  intervalType?: string;
  creditAmount?: string;
  expireTime?: string;
  status?: string;
  from?: string;
}

export interface VapidPublicKeyView {
  publicKey?: string;
}

export interface DiscordBindingStatusVO {
  bound?: boolean;
  discordUserId?: string;
}

export interface UserCreditVo {
  creditAmount?: string;
  creditDetailList?: CreditDetailVo[];
}

export interface UserCreditTransactionPageVo {
  list?: UserCreditTransactionVo[];
  nextContinuationToken?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  total?: number;
}

export interface CreditPackagePageVo {
  creditPackageList?: CreditPackageVo[];
  maxDiscount?: DiscountInfo;
}

export interface CreditPackageVo {
  amount?: string;
  price?: string;
  priceId?: string;
  description?: string;
}

export interface DiscountInfo {
  type?: string;
  /** @format double */
  value?: number;
  description?: string;
}

export interface CouponVo {
  /** @format int64 */
  id?: number;
  couponCode?: string;
  outCouponId?: string;
  discount?: DiscountInfo;
}

export interface AuthVo {
  codes?: string[];
}

export interface ListResponseByPageAssetView {
  list?: AssetView[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface DailyUsage {
  /** @format int32 */
  current?: number;
  /** @format int32 */
  threshold?: number;
}

export interface UserDailyUsageVO {
  userId?: string;
  usage?: Record<string, DailyUsage>;
}

export interface SceneKnowledgeBaseDetail {
  id?: string;
  name?: string;
}

export interface UserDetailInfoResponse {
  userInfo?: UserProfile;
  planInfo?: UserPlanInfo;
  userPlans?: UserPlanItem[];
  creditBalance?: UserCreditVo;
}

export interface UserPlanInfo {
  currentPlanCode?: string;
  currentPlanName?: string;
  expireTime?: string;
  nextRenewTime?: string;
  hasActivePlan?: boolean;
}

export interface UserPlanItem {
  planCode?: string;
  planName?: string;
  expireTime?: string;
  nextRenewTime?: string;
  from?: string;
}

export interface ListResponseByPageOrderInfo {
  list?: OrderInfo[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface OrderInfo {
  /** @format int64 */
  id?: number;
  outerOrderId?: string;
  outerPlatform?: string;
  from?: string;
  /** @format int64 */
  amount?: number;
  currency?: string;
  status?: string;
  createTime?: string;
}

export interface TempUserInfo {
  email?: string;
  password?: string;
}

export interface ListResponseByPageThreadInfoResponse {
  list?: ThreadInfoResponse[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface ThreadInfoResponse {
  zeusThreadId?: string;
  aionThreadId?: string;
  title?: string;
  /** @format date-time */
  createTime?: string;
  userInput?: string;
  /** @format int32 */
  consumedCredits?: number;
  creditsByReasonSubType?: Record<string, number>;
}

export interface ListResponseByPageRedemptionCodeItemResponse {
  list?: RedemptionCodeItemResponse[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface RedemptionCodeItemResponse {
  /** @format int64 */
  id?: number;
  code?: string;
  batchNo?: string;
  planCode?: string;
  status?: string;
  /** @format date-time */
  expireAt?: string;
  /** @format date-time */
  usedAt?: string;
  /** @format int64 */
  usedByUserId?: number;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface SystemPromptResponse {
  content?: string;
}

export interface UserActivityVo {
  activityCode?: string;
  status?: string;
  /** @format date-time */
  joinTime?: string;
  /** @format date-time */
  convertTime?: string;
  /** @format date-time */
  expireTime?: string;
}

export interface UserPlanInfoResponse {
  /** @format int64 */
  userId?: number;
  email?: string;
  nickname?: string;
  currentPlanCode?: string;
  currentPlanName?: string;
  expireTime?: string;
  nextRenewTime?: string;
  hasActivePlan?: boolean;
  userActivities?: UserActivityVo[];
}

export interface FeedbackResponse {
  /** @format int64 */
  id?: number;
  /** @format int64 */
  userId?: number;
  email?: string;
  type?: FeedbackResponseType;
  subType?: string;
  content?: string;
  status?: FeedbackResponseStatus;
  emailContent?: string;
  owner?: string;
  problemType?: FeedbackResponseProblemType;
  recommendHandle?: string;
  /** @format date-time */
  createTime?: string;
  /** @format date-time */
  updateTime?: string;
}

export interface ListResponseByPageFeedbackResponse {
  list?: FeedbackResponse[];
  /** @format int32 */
  total?: number;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
}

export interface CreditBalanceResponse {
  /** @format double */
  balance?: number;
}

export interface ActivityVo {
  activityCode?: string;
  name?: string;
  description?: string;
  activityType?: string;
  trialPrice?: string;
  regularPrice?: string;
  /** @format int32 */
  trialDays?: number;
  creditPackageOptions?: CreditPackageOptionVo[];
}

export interface CreditPackageOptionVo {
  optionId?: string;
  name?: string;
  price?: number;
  currency?: string;
  /** @format int32 */
  creditAmount?: number;
  originalPrice?: number;
  /** @format int32 */
  discountPercent?: number;
  tag?: string;
  recommended?: boolean;
}

export enum AgentThreadVoStatus {
  WorkflowGenerated = "workflow_generated",
  Pending = "pending",
  Running = "running",
  Success = "success",
  Terminated = "terminated",
  Failed = "failed",
  Waiting = "waiting",
  Stopping = "stopping",
}

export enum UpdateArtifactsRequestArtifactType {
  ValueVideoAnalysisResultArtifact = "<Video Analysis Result Artifact>",
  ValueAudioAnalysisResultArtifact = "<Audio Analysis Result Artifact>",
  ValueScriptArtifact = "<Script Artifact>",
  ValueCreativeSummaryArtifact = "<Creative Summary Artifact>",
  ValueShotsArtifact = "<Shots Artifact>",
  ValueOriginalSubtitlesArtifact = "<Original Subtitles Artifact>",
  ValueAdjustedSubtitlesArtifact = "<Adjusted Subtitles Artifact>",
  ValueSpeechArtifact = "<Speech Artifact>",
  ValueMusicClipsArtifact = "<Music Clips Artifact>",
  ValueOTIOTimelineArtifact = "<OTIO Timeline Artifact>",
  ValueFinalResultArtifact = "<Final Result Artifact>",
  ValueSelectedVoiceArtifact = "<Selected Voice Artifact>",
  ValueLineSubtitlesArtifact = "<Line Subtitles Artifact>",
  ValueReferenceImageArtifact = "<Reference Image Artifact>",
  ValueCharacterVoiceArtifact = "<Character Voice Artifact>",
}

export enum ApplyArtifactFileVersionRequestArtifactType {
  ValueVideoAnalysisResultArtifact = "<Video Analysis Result Artifact>",
  ValueAudioAnalysisResultArtifact = "<Audio Analysis Result Artifact>",
  ValueScriptArtifact = "<Script Artifact>",
  ValueCreativeSummaryArtifact = "<Creative Summary Artifact>",
  ValueShotsArtifact = "<Shots Artifact>",
  ValueOriginalSubtitlesArtifact = "<Original Subtitles Artifact>",
  ValueAdjustedSubtitlesArtifact = "<Adjusted Subtitles Artifact>",
  ValueSpeechArtifact = "<Speech Artifact>",
  ValueMusicClipsArtifact = "<Music Clips Artifact>",
  ValueOTIOTimelineArtifact = "<OTIO Timeline Artifact>",
  ValueFinalResultArtifact = "<Final Result Artifact>",
  ValueSelectedVoiceArtifact = "<Selected Voice Artifact>",
  ValueLineSubtitlesArtifact = "<Line Subtitles Artifact>",
  ValueReferenceImageArtifact = "<Reference Image Artifact>",
  ValueCharacterVoiceArtifact = "<Character Voice Artifact>",
}

export enum ApplyArtifactFileVersionRequestFileType {
  StartFrameImage = "start_frame_image",
  VideoClip = "video_clip",
  MusicClip = "music_clip",
  ReferenceImage = "reference_image",
}

export enum AgentThreadControlSignalDtoSignal {
  ValueCtrlTerminate = "<ctrl:terminate>",
  ValueCtrlStop = "<ctrl:stop>",
  ValueCtrlStopImmediately = "<ctrl:stop-immediately>",
  ValueCtrlCancel = "<ctrl:cancel>",
  ValueCtrlContinue = "<ctrl:continue>",
  ValueCtrlAutoModeEnable = "<ctrl:auto-mode=enable>",
  ValueCtrlAutoModeDisable = "<ctrl:auto-mode=disable>",
}

export enum SubscribeRequestType {
  WEB_PUSH = "WEB_PUSH",
}

export enum SubscriptionViewType {
  WEB_PUSH = "WEB_PUSH",
}

export enum VerifyPermissionRequestFunction {
  VID_MUSE = "VID_MUSE",
}

export enum GenerateInvitationCodeRequestFunctions {
  VID_MUSE = "VID_MUSE",
}

/** 反馈类型 */
export enum FeedbackSubmitRequestType {
  Onboarding = "onboarding",
  Feedback = "feedback",
}

export enum SetConfigRequestConfigServiceEnum {
  REDIS_CONFIG = "REDIS_CONFIG",
}

export enum GetConfigRequestConfigServiceEnum {
  REDIS_CONFIG = "REDIS_CONFIG",
}

export enum DeleteConfigRequestConfigServiceEnum {
  REDIS_CONFIG = "REDIS_CONFIG",
}

export enum AssetViewMediaType {
  JPEG = "JPEG",
  PNG = "PNG",
  WEBP = "WEBP",
  MP4 = "MP4",
  TransportStream = "TransportStream",
  FLV = "FLV",
  QuickTime = "QuickTime",
  MPEG = "MPEG",
  WEBM_VIDEO = "WEBM_VIDEO",
  WMV = "WMV",
  THREE_GPP = "THREE_GPP",
  WAV = "WAV",
  AAC = "AAC",
  FLAC = "FLAC",
  MP3 = "MP3",
  M4A = "M4A",
  OPUS = "OPUS",
  PCM = "PCM",
  WEBM_AUDIO = "WEBM_AUDIO",
}

export enum AssetViewSource {
  Upload = "Upload",
  Generate = "Generate",
  GenerateFirstFrame = "GenerateFirstFrame",
  ExtractVideoPoster = "ExtractVideoPoster",
  Crop = "Crop",
  AvatarDownload = "AvatarDownload",
  AvatarUpload = "AvatarUpload",
  InspirationFirstFrameCandidate = "InspirationFirstFrameCandidate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  SourceVideoToTs = "SourceVideoToTs",
  VoicePreview = "VoicePreview",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

export enum AgentEventRequestName {
  STATUS_CHANGE = "STATUS_CHANGE",
  VIDEO_RENDER_SUCCESS = "VIDEO_RENDER_SUCCESS",
}

/** 流程状态：1待分析，2待人工处理，3已处理 */
export enum FeedbackUpdateRequestStatus {
  Value1 = "1",
  Value2 = "2",
  Value3 = "3",
}

/** 问题类型：engineering_bug(工程BUG)，effect_issue(效果问题)，product_issue(产品问题) */
export enum FeedbackUpdateRequestProblemType {
  EngineeringBug = "engineering_bug",
  EffectIssue = "effect_issue",
  ProductIssue = "product_issue",
}

export enum ButtonComponentStyle {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  SUCCESS = "SUCCESS",
  DANGER = "DANGER",
  LINK = "LINK",
}

export enum AgentThreadTaskStatus {
  Pending = "pending",
  Running = "running",
  Success = "success",
  Failed = "failed",
}

export enum AgentThreadMessageDetailType {
  User = "user",
  Assistant = "assistant",
  Tool = "tool",
  System = "system",
  Developer = "developer",
  Function = "function",
  Rtc = "rtc",
  Checkpoint = "checkpoint",
}

export enum AgentThreadMessageDetailStatus {
  Done = "done",
  Appending = "appending",
  Waiting = "waiting",
  Reverted = "reverted",
}

export enum PlatformCreditPackageStatus {
  ACTIVE = "ACTIVE",
  DEPRECATED = "DEPRECATED",
  OFFLINE = "OFFLINE",
}

export enum FeedbackResponseType {
  Onboarding = "onboarding",
  Feedback = "feedback",
}

export enum FeedbackResponseStatus {
  Value1 = "1",
  Value2 = "2",
  Value3 = "3",
}

export enum FeedbackResponseProblemType {
  EngineeringBug = "engineering_bug",
  EffectIssue = "effect_issue",
  ProductIssue = "product_issue",
}

export enum UploadArtifactFileParamsArtifactType {
  ValueVideoAnalysisResultArtifact = "<Video Analysis Result Artifact>",
  ValueAudioAnalysisResultArtifact = "<Audio Analysis Result Artifact>",
  ValueScriptArtifact = "<Script Artifact>",
  ValueCreativeSummaryArtifact = "<Creative Summary Artifact>",
  ValueShotsArtifact = "<Shots Artifact>",
  ValueOriginalSubtitlesArtifact = "<Original Subtitles Artifact>",
  ValueAdjustedSubtitlesArtifact = "<Adjusted Subtitles Artifact>",
  ValueSpeechArtifact = "<Speech Artifact>",
  ValueMusicClipsArtifact = "<Music Clips Artifact>",
  ValueOTIOTimelineArtifact = "<OTIO Timeline Artifact>",
  ValueFinalResultArtifact = "<Final Result Artifact>",
  ValueSelectedVoiceArtifact = "<Selected Voice Artifact>",
  ValueLineSubtitlesArtifact = "<Line Subtitles Artifact>",
  ValueReferenceImageArtifact = "<Reference Image Artifact>",
  ValueCharacterVoiceArtifact = "<Character Voice Artifact>",
}

export enum ListAssetsParamsSources {
  Upload = "Upload",
  Generate = "Generate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

export enum ListAssetsParamsTypes {
  Video = "Video",
  Image = "Image",
  Audio = "Audio",
}

/** @default "Upload" */
export enum UploadAssetParamsSource {
  Upload = "Upload",
  Generate = "Generate",
  GenerateFirstFrame = "GenerateFirstFrame",
  ExtractVideoPoster = "ExtractVideoPoster",
  Crop = "Crop",
  AvatarDownload = "AvatarDownload",
  AvatarUpload = "AvatarUpload",
  InspirationFirstFrameCandidate = "InspirationFirstFrameCandidate",
  Featured = "Featured",
  HumanFeatured = "HumanFeatured",
  SourceVideoToTs = "SourceVideoToTs",
  VoicePreview = "VoicePreview",
  TextToSpeech = "TextToSpeech",
  CreateImage = "CreateImage",
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "https://vidmuse-dev.sandaii.cn",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl https://vidmuse-dev.sandaii.cn
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  user = {
    /**
     * No description
     *
     * @tags User
     * @name CurrentUserProfile
     * @request GET:/api/v1/user/profile
     * @response `200` `UserProfile` OK
     */
    currentUserProfile: (params: RequestParams = {}) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/profile`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdateUserProfile
     * @request PUT:/api/v1/user/profile
     * @response `200` `IDOnlyResponse` OK
     */
    updateUserProfile: (
      data: UserProfileUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/user/profile`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SendLoginCode
     * @request POST:/api/v1/user/send-login-code
     * @response `200` `EmptySuccessResponse` OK
     */
    sendLoginCode: (
      data: UserEmailCodeSendRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/user/send-login-code`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Bind a referral code to the current user. This should be called when a new user registers via referral link
     *
     * @tags Referral
     * @name BindReferralCode
     * @summary Bind referral code
     * @request POST:/api/v1/user/referral/bind
     * @response `200` `IDOnlyResponse` OK
     */
    bindReferralCode: (
      data: BindReferralCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/user/referral/bind`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 注销当前登录用户并失效当前会话
     *
     * @tags User
     * @name DeactivateUser
     * @summary 注销当前用户
     * @request POST:/api/v1/user/profile/deactivate
     * @response `200` `EmptySuccessResponse` OK
     */
    deactivateUser: (params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/user/profile/deactivate`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name LoginWithCode
     * @request POST:/api/v1/user/login-with-code
     * @response `200` `UserProfile` OK
     */
    loginWithCode: (
      data: UserEmailCodeVerifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserProfile, any>({
        path: `/api/v1/user/login-with-code`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the referral code for the current user
     *
     * @tags Referral
     * @name GetReferralLink
     * @summary Get referral code
     * @request GET:/api/v1/user/referral/referral-code
     * @response `200` `ReferralLinkResponse` OK
     */
    getReferralLink: (params: RequestParams = {}) =>
      this.request<ReferralLinkResponse, any>({
        path: `/api/v1/user/referral/referral-code`,
        method: "GET",
        ...params,
      }),
  };
  threads = {
    /**
     * No description
     *
     * @tags Agent
     * @name GetThreadDetail
     * @request GET:/api/v1/threads/{threadId}
     * @response `200` `AgentThreadVo` OK
     */
    getThreadDetail: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name UpdateThread
     * @request PUT:/api/v1/threads/{threadId}
     * @response `200` `AgentThreadVo` OK
     */
    updateThread: (
      threadId: string,
      data: AgentThreadUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name DeleteThread
     * @request DELETE:/api/v1/threads/{threadId}
     * @response `200` `void` OK
     */
    deleteThread: (threadId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/threads/${threadId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name GetThreadArtifacts
     * @request GET:/api/v1/threads/{threadId}/artifacts
     * @response `200` `StreamingResponseBody` OK
     */
    getThreadArtifacts: (
      threadId: string,
      query?: {
        /** @default false */
        multi_version?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<StreamingResponseBody, any>({
        path: `/api/v1/threads/${threadId}/artifacts`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name UpdateThreadArtifacts
     * @request PUT:/api/v1/threads/{threadId}/artifacts
     * @response `200` `Record<string,object>` OK
     */
    updateThreadArtifacts: (
      threadId: string,
      data: UpdateArtifactsRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/artifacts`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ApplyArtifactFileVersion
     * @request PUT:/api/v1/threads/{threadId}/artifacts/file-version
     * @response `200` `Record<string,object>` OK
     */
    applyArtifactFileVersion: (
      threadId: string,
      data: ApplyArtifactFileVersionRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/artifacts/file-version`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ListThreads
     * @request GET:/api/v1/threads
     * @response `200` `ListResponseByPageAgentThreadVo` OK
     */
    listThreads: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadVo, any>({
        path: `/api/v1/threads`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name CreateThread
     * @request POST:/api/v1/threads
     * @response `200` `AgentThreadVo` OK
     */
    createThread: (
      query: {
        files: File[];
        file_urls?: string;
        user_input?: string;
        auto_mode?: boolean;
        options?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name VoteThread
     * @request POST:/api/v1/threads/{threadId}/vote
     * @response `200` `void` OK
     */
    voteThread: (
      threadId: string,
      data: MessageVoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/threads/${threadId}/vote`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name CallTool
     * @request POST:/api/v1/threads/{threadId}/tools/{toolType}
     * @response `200` `Record<string,object>` OK
     */
    callTool: (
      threadId: string,
      toolType: string,
      data: AgentToolCallRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/tools/${toolType}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name GetSharedThread
     * @request GET:/api/v1/threads/{threadId}/share
     * @response `200` `AgentThreadShareVo` OK
     */
    getSharedThread: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadShareVo, any>({
        path: `/api/v1/threads/${threadId}/share`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ShareThread
     * @request POST:/api/v1/threads/{threadId}/share
     * @response `200` `AgentThreadVo` OK
     */
    shareThread: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/share`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ReactiveThread
     * @request POST:/api/v1/threads/{threadId}/reactive
     * @response `200` `ThreadReactiveVO` OK
     */
    reactiveThread: (
      threadId: string,
      query: {
        auto_mode: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThreadReactiveVO, any>({
        path: `/api/v1/threads/${threadId}/reactive`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name NameThreadByAi
     * @request POST:/api/v1/threads/{threadId}/name-by-ai
     * @response `200` `AgentThreadVo` OK
     */
    nameThreadByAi: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/name-by-ai`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ListMessages
     * @request GET:/api/v1/threads/{threadId}/messages
     * @response `200` `ListResponseByPageAgentThreadMessageDetail` OK
     */
    listMessages: (
      threadId: string,
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadMessageDetail, any>({
        path: `/api/v1/threads/${threadId}/messages`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name SendMessage
     * @request POST:/api/v1/threads/{threadId}/messages
     * @response `200` `AgentThreadMessageQueueResponse` OK
     */
    sendMessage: (
      threadId: string,
      query: {
        files: File[];
        file_urls?: string;
        text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadMessageQueueResponse, any>({
        path: `/api/v1/threads/${threadId}/messages`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description 对指定消息进行点赞、点踩或取消投票。需要登录。 请求体 value: 1=点赞(like), -1=点踩(dislike), 0=取消(cancel)。
     *
     * @tags Agent
     * @name VoteMessage
     * @summary 消息点赞/点踩/取消
     * @request POST:/api/v1/threads/{threadId}/messages/{messageId}/vote
     * @response `200` `void` OK
     */
    voteMessage: (
      threadId: string,
      messageId: string,
      data: MessageVoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/threads/${threadId}/messages/${messageId}/vote`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ControlThread
     * @request POST:/api/v1/threads/{threadId}/control
     * @response `200` `AgentThreadMessageQueueResponse` OK
     */
    controlThread: (
      threadId: string,
      data: AgentThreadControlSignalDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadMessageQueueResponse, any>({
        path: `/api/v1/threads/${threadId}/control`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name UpdateThreadAutoMode
     * @request POST:/api/v1/threads/{threadId}/auto-mode
     * @response `200` `AgentThreadVo` OK
     */
    updateThreadAutoMode: (
      threadId: string,
      data: AgentThreadAutoModeDto,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/threads/${threadId}/auto-mode`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name UploadArtifactFile
     * @request POST:/api/v1/threads/{threadId}/artifacts/file
     * @response `200` `UploadArtifactFileResponse` OK
     */
    uploadArtifactFile: (
      threadId: string,
      query: {
        artifact_type: UploadArtifactFileParamsArtifactType;
        /** @default "" */
        data?: string;
      },
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadArtifactFileResponse, any>({
        path: `/api/v1/threads/${threadId}/artifacts/file`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name GetThreadVoices
     * @request GET:/api/v1/threads/{threadId}/voices
     * @response `200` `StreamingResponseBody` OK
     */
    getThreadVoices: (threadId: string, params: RequestParams = {}) =>
      this.request<StreamingResponseBody, any>({
        path: `/api/v1/threads/${threadId}/voices`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ListTools
     * @request GET:/api/v1/threads/{threadId}/tools
     * @response `200` `Record<string,ToolInfoDto>` OK
     */
    listTools: (threadId: string, params: RequestParams = {}) =>
      this.request<Record<string, ToolInfoDto>, any>({
        path: `/api/v1/threads/${threadId}/tools`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ListRemoteToolCallTasks
     * @request GET:/api/v1/threads/{threadId}/tasks/rtc
     * @response `200` `(AgentThreadTask)[]` OK
     */
    listRemoteToolCallTasks: (threadId: string, params: RequestParams = {}) =>
      this.request<AgentThreadTask[], any>({
        path: `/api/v1/threads/${threadId}/tasks/rtc`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name GetThreadOptions
     * @request GET:/api/v1/threads/{threadId}/options
     * @response `200` `Record<string,object>` OK
     */
    getThreadOptions: (threadId: string, params: RequestParams = {}) =>
      this.request<Record<string, object>, any>({
        path: `/api/v1/threads/${threadId}/options`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name StreamMessages
     * @request GET:/api/v1/threads/{threadId}/messages/sse
     * @response `200` `SseEmitter` OK
     */
    streamMessages: (threadId: string, params: RequestParams = {}) =>
      this.request<SseEmitter, any>({
        path: `/api/v1/threads/${threadId}/messages/sse`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ExportTimeline
     * @request GET:/api/v1/threads/{threadId}/export-timeline
     * @response `200` `StreamingResponseBody` OK
     */
    exportTimeline: (threadId: string, params: RequestParams = {}) =>
      this.request<StreamingResponseBody, any>({
        path: `/api/v1/threads/${threadId}/export-timeline`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name GetThreadCredits
     * @request GET:/api/v1/threads/{threadId}/credits
     * @response `200` `ThreadCreditsVO` OK
     */
    getThreadCredits: (threadId: string, params: RequestParams = {}) =>
      this.request<ThreadCreditsVO, any>({
        path: `/api/v1/threads/${threadId}/credits`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent
     * @name ListCommunityThreads
     * @request GET:/api/v1/threads/community
     * @response `200` `ListResponseByPageAgentThreadVo` OK
     */
    listCommunityThreads: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAgentThreadVo, any>({
        path: `/api/v1/threads/community`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  plans = {
    /**
     * No description
     *
     * @tags Plan
     * @name CancelUserPlan
     * @request PUT:/api/v1/plans/user/{priceId}/cancel
     * @response `200` `EmptySuccessResponse` OK
     */
    cancelUserPlan: (priceId: string, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/plans/user/${priceId}/cancel`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plan
     * @name QueryActivePlans
     * @request GET:/api/v1/plans
     * @response `200` `PlanPageVo` OK
     */
    queryActivePlans: (params: RequestParams = {}) =>
      this.request<PlanPageVo, any>({
        path: `/api/v1/plans`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plan
     * @name QueryUserPlan
     * @request GET:/api/v1/plans/user
     * @response `200` `UserPlanVo` OK
     */
    queryUserPlan: (params: RequestParams = {}) =>
      this.request<UserPlanVo, any>({
        path: `/api/v1/plans/user`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plan
     * @name QueryUserPlanList
     * @request GET:/api/v1/plans/user/list
     * @response `200` `(UserPlanVo)[]` OK
     */
    queryUserPlanList: (params: RequestParams = {}) =>
      this.request<UserPlanVo[], any>({
        path: `/api/v1/plans/user/list`,
        method: "GET",
        ...params,
      }),
  };
  admin = {
    /**
     * @description 获取总结用户项目的 system_prompt
     *
     * @tags Admin
     * @name GetThreadSummaryPrompt
     * @summary Get thread summary system prompt
     * @request GET:/api/v1/admin/prompts/thread-summary
     * @response `200` `SystemPromptResponse` OK
     */
    getThreadSummaryPrompt: (params: RequestParams = {}) =>
      this.request<SystemPromptResponse, any>({
        path: `/api/v1/admin/prompts/thread-summary`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 更新总结用户项目的 system_prompt
     *
     * @tags Admin
     * @name UpdateThreadSummaryPrompt
     * @summary Update thread summary system prompt
     * @request PUT:/api/v1/admin/prompts/thread-summary
     * @response `200` `EmptySuccessResponse` OK
     */
    updateThreadSummaryPrompt: (
      data: SystemPromptUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/admin/prompts/thread-summary`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 获取分析用户反馈的 system_prompt
     *
     * @tags Admin
     * @name GetFeedbackAnalysisPrompt
     * @summary Get feedback analysis system prompt
     * @request GET:/api/v1/admin/prompts/feedback-analysis
     * @response `200` `SystemPromptResponse` OK
     */
    getFeedbackAnalysisPrompt: (params: RequestParams = {}) =>
      this.request<SystemPromptResponse, any>({
        path: `/api/v1/admin/prompts/feedback-analysis`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 更新分析用户反馈的 system_prompt
     *
     * @tags Admin
     * @name UpdateFeedbackAnalysisPrompt
     * @summary Update feedback analysis system prompt
     * @request PUT:/api/v1/admin/prompts/feedback-analysis
     * @response `200` `EmptySuccessResponse` OK
     */
    updateFeedbackAnalysisPrompt: (
      data: SystemPromptUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/admin/prompts/feedback-analysis`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name UnbanUser
     * @request POST:/api/v1/admin/users/unban
     * @response `200` `GeneralResponse` OK
     */
    unbanUser: (data: AdminBanUserRequest, params: RequestParams = {}) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/users/unban`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AddSuperAdminUser
     * @request POST:/api/v1/admin/users/super-admin
     * @response `200` `GeneralResponse` OK
     */
    addSuperAdminUser: (
      data: AddSuperAdminRequest,
      params: RequestParams = {},
    ) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/users/super-admin`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GenerateAccessToken
     * @request POST:/api/v1/admin/users/generate-access-token
     * @response `200` `GenerateAccessTokenResponse` OK
     */
    generateAccessToken: (
      data: GenerateAccessTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenerateAccessTokenResponse, any>({
        path: `/api/v1/admin/users/generate-access-token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name BanUser
     * @request POST:/api/v1/admin/users/ban
     * @response `200` `GeneralResponse` OK
     */
    banUser: (data: AdminBanUserRequest, params: RequestParams = {}) =>
      this.request<GeneralResponse, any>({
        path: `/api/v1/admin/users/ban`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name BatchGenerate
     * @request POST:/api/v1/admin/redemption-codes/batch-generate
     * @response `200` `BatchGenerateRedemptionCodeResponse` OK
     */
    batchGenerate: (
      data: BatchGenerateRedemptionCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<BatchGenerateRedemptionCodeResponse, any>({
        path: `/api/v1/admin/redemption-codes/batch-generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetSubscriptionBonusPromotion
     * @summary Get subscription bonus promotion config
     * @request GET:/api/v1/admin/promotion/subscription-bonus
     * @response `200` `SubscriptionBonusPromotion` OK
     */
    getSubscriptionBonusPromotion: (params: RequestParams = {}) =>
      this.request<SubscriptionBonusPromotion, any>({
        path: `/api/v1/admin/promotion/subscription-bonus`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SetSubscriptionBonusPromotion
     * @summary Set subscription bonus promotion config
     * @request POST:/api/v1/admin/promotion/subscription-bonus
     * @response `200` `EmptySuccessResponse` OK
     */
    setSubscriptionBonusPromotion: (
      data: SubscriptionBonusPromotion,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/admin/promotion/subscription-bonus`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetCreditPackagePromotion
     * @summary Get credit package promotion config
     * @request GET:/api/v1/admin/promotion/credit-package
     * @response `200` `CreditPackagePromotion` OK
     */
    getCreditPackagePromotion: (params: RequestParams = {}) =>
      this.request<CreditPackagePromotion, any>({
        path: `/api/v1/admin/promotion/credit-package`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name SetCreditPackagePromotion
     * @summary Set credit package promotion config
     * @request POST:/api/v1/admin/promotion/credit-package
     * @response `200` `EmptySuccessResponse` OK
     */
    setCreditPackagePromotion: (
      data: CreditPackagePromotion,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/admin/promotion/credit-package`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GrantMembership
     * @request POST:/api/v1/admin/plans/grant-membership
     * @response `200` `GrantMembershipResultResponse` OK
     */
    grantMembership: (
      data: GrantMembershipRequest,
      params: RequestParams = {},
    ) =>
      this.request<GrantMembershipResultResponse, any>({
        path: `/api/v1/admin/plans/grant-membership`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name UpdateFeedback
     * @request POST:/api/v1/admin/feedback/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    updateFeedback: (
      id: number,
      data: FeedbackUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/admin/feedback/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DeleteFeedback
     * @request DELETE:/api/v1/admin/feedback/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteFeedback: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/admin/feedback/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ReplyEmail
     * @request POST:/api/v1/admin/feedback/{id}/reply-email
     * @response `200` `EmptySuccessResponse` OK
     */
    replyEmail: (id: number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/admin/feedback/${id}/reply-email`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Admin-only endpoint to send formatted embed messages with optional buttons to Discord channels
     *
     * @tags Admin
     * @name SendMessage1
     * @summary Send rich embed message to Discord channel
     * @request POST:/api/v1/admin/discord/send-message
     * @response `200` `SendDiscordMessageResponse` OK
     */
    sendMessage1: (
      data: SendDiscordMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<SendDiscordMessageResponse, any>({
        path: `/api/v1/admin/discord/send-message`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name IssueUserCredit
     * @request POST:/api/v1/admin/credits/operate/user
     * @response `200` `void` OK
     */
    issueUserCredit: (
      data: IssueUserCreditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/credits/operate/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name IssueOrgCredit
     * @request POST:/api/v1/admin/credits/operate/org
     * @response `200` `void` OK
     */
    issueOrgCredit: (data: IssueOrgCreditRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/credits/operate/org`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DeductCredit
     * @request POST:/api/v1/admin/credits/deduct
     * @response `200` `IDOnlyResponse` OK
     */
    deductCredit: (data: DeductCreditRequest, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/admin/credits/deduct`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ConfirmDeduction
     * @request POST:/api/v1/admin/credits/confirm
     * @response `200` `IDOnlyResponse` OK
     */
    confirmDeduction: (
      data: ConfirmDeductionRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/admin/credits/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name CancelDeduction
     * @request POST:/api/v1/admin/credits/cancel
     * @response `200` `IDOnlyResponse` OK
     */
    cancelDeduction: (
      data: CancelDeductionRequest,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/admin/credits/cancel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name UpdateThread1
     * @request PATCH:/api/v1/admin/threads/{threadId}
     * @response `200` `AgentThreadVo` OK
     */
    updateThread1: (
      threadId: string,
      data: UpdateThreadRequest,
      params: RequestParams = {},
    ) =>
      this.request<AgentThreadVo, any>({
        path: `/api/v1/admin/threads/${threadId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetUserDetail
     * @request GET:/api/v1/admin/users/detail
     * @response `200` `UserDetailInfoResponse` OK
     */
    getUserDetail: (
      query?: {
        email?: string;
        /** @format int64 */
        userId?: number;
        threadId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDetailInfoResponse, any>({
        path: `/api/v1/admin/users/detail`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetUserOrders
     * @request GET:/api/v1/admin/users/detail/orders
     * @response `200` `ListResponseByPageOrderInfo` OK
     */
    getUserOrders: (
      query?: {
        email?: string;
        /** @format int64 */
        userId?: number;
        threadId?: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageOrderInfo, any>({
        path: `/api/v1/admin/users/detail/orders`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetUserCreditTransactions
     * @request GET:/api/v1/admin/users/detail/credit-transactions
     * @response `200` `ListResponseByPageUserCreditTransactionVo` OK
     */
    getUserCreditTransactions: (
      query?: {
        email?: string;
        /** @format int64 */
        userId?: number;
        threadId?: string;
        direction?: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageUserCreditTransactionVo, any>({
        path: `/api/v1/admin/users/detail/credit-transactions`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name CreateTempUserAccount
     * @request GET:/api/v1/admin/users/create-temp-user-account
     * @response `200` `(TempUserInfo)[]` OK
     */
    createTempUserAccount: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        count?: number;
        /** @default false */
        addToLoginWhiteList?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TempUserInfo[], any>({
        path: `/api/v1/admin/users/create-temp-user-account`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetThreadsByEmail
     * @request GET:/api/v1/admin/threads/user/by-email
     * @response `200` `ListResponseByPageThreadInfoResponse` OK
     */
    getThreadsByEmail: (
      query: {
        email: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageThreadInfoResponse, any>({
        path: `/api/v1/admin/threads/user/by-email`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name List
     * @request GET:/api/v1/admin/redemption-codes
     * @response `200` `ListResponseByPageRedemptionCodeItemResponse` OK
     */
    list: (
      query?: {
        batchNo?: string;
        status?: string;
        /** @format int64 */
        usedByUserId?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageRedemptionCodeItemResponse, any>({
        path: `/api/v1/admin/redemption-codes`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetUserPlanInfo
     * @request GET:/api/v1/admin/plans/user/{userId}
     * @response `200` `UserPlanInfoResponse` OK
     */
    getUserPlanInfo: (userId: number, params: RequestParams = {}) =>
      this.request<UserPlanInfoResponse, any>({
        path: `/api/v1/admin/plans/user/${userId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetUserPlanInfoByEmail
     * @request GET:/api/v1/admin/plans/user/by-email
     * @response `200` `UserPlanInfoResponse` OK
     */
    getUserPlanInfoByEmail: (
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPlanInfoResponse, any>({
        path: `/api/v1/admin/plans/user/by-email`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetFeedbacks
     * @request GET:/api/v1/admin/feedback
     * @response `200` `ListResponseByPageFeedbackResponse` OK
     */
    getFeedbacks: (
      query?: {
        /** @format int64 */
        id?: number;
        /** @format int64 */
        userId?: number;
        email?: string;
        type?: string;
        /** @format int32 */
        status?: number;
        problemType?: string;
        owner?: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageFeedbackResponse, any>({
        path: `/api/v1/admin/feedback`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name GetCreditBalance
     * @request GET:/api/v1/admin/credits/balance
     * @response `200` `CreditBalanceResponse` OK
     */
    getCreditBalance: (
      query: {
        /** @format int64 */
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreditBalanceResponse, any>({
        path: `/api/v1/admin/credits/balance`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  payment = {
    /**
     * No description
     *
     * @tags Payment
     * @name Handle
     * @request POST:/payment/stripe/v2/webhook
     * @response `200` `StreamingResponseBody` OK
     */
    handle: (params: RequestParams = {}) =>
      this.request<StreamingResponseBody, any>({
        path: `/payment/stripe/v2/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name JoinTrialActivity
     * @summary 参与试用活动
     * @request GET:/payment/sessions/trial/join
     * @response `200` `void` OK
     */
    joinTrialActivity: (
      query: {
        activityCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/payment/sessions/trial/join`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name CreatePortalSession
     * @request GET:/payment/sessions/portal
     * @response `200` `void` OK
     */
    createPortalSession: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/payment/sessions/portal`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PurchaseCreditPackage
     * @summary 购买活动积分包
     * @request GET:/payment/sessions/credit-package/purchase
     * @response `200` `void` OK
     */
    purchaseCreditPackage: (
      query: {
        activityCode: string;
        optionId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/payment/sessions/credit-package/purchase`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name CreateCheckoutSession
     * @request GET:/payment/sessions/checkout
     * @response `200` `void` OK
     */
    createCheckoutSession: (
      query: {
        priceId: string;
        /** @format int64 */
        couponId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/payment/sessions/checkout`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @tags Report
     * @name CreateReport
     * @request POST:/api/v1/reports
     * @response `200` `void` OK
     */
    createReport: (data: ReportCreateRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/reports`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name GetReportReasons
     * @request GET:/api/v1/reports/tags
     * @response `200` `ReportTagsVo` OK
     */
    getReportReasons: (params: RequestParams = {}) =>
      this.request<ReportTagsVo, any>({
        path: `/api/v1/reports/tags`,
        method: "GET",
        ...params,
      }),
  };
  redemptionCodes = {
    /**
     * No description
     *
     * @tags RedemptionCode
     * @name UseRedemptionCode
     * @request POST:/api/v1/redemption-codes/use
     * @response `200` `UseRedemptionCodeVo` OK
     */
    useRedemptionCode: (
      data: UseRedemptionCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UseRedemptionCodeVo, any>({
        path: `/api/v1/redemption-codes/use`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  platform = {
    /**
     * No description
     *
     * @tags Platform
     * @name CreateCustomApiPackageRequest
     * @request POST:/api/v1/platform/feedback/custom-api-package-request
     * @response `200` `IDOnlyResponse` OK
     */
    createCustomApiPackageRequest: (
      data: CustomApiPackageRequestVo,
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/platform/feedback/custom-api-package-request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name GetApiKeyList
     * @request GET:/api/v1/platform/api-keys
     * @response `200` `(ApiKeyVo)[]` OK
     */
    getApiKeyList: (params: RequestParams = {}) =>
      this.request<ApiKeyVo[], any>({
        path: `/api/v1/platform/api-keys`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name CreateApiKey
     * @request POST:/api/v1/platform/api-keys
     * @response `200` `ApiKey` OK
     */
    createApiKey: (data: ApiKeyRequest, params: RequestParams = {}) =>
      this.request<ApiKey, any>({
        path: `/api/v1/platform/api-keys`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name GetPlatformOrders
     * @request GET:/api/v1/platform/orders
     * @response `200` `ListResponseByPagePlatformOrderVo` OK
     */
    getPlatformOrders: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPagePlatformOrderVo, any>({
        path: `/api/v1/platform/orders`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name GetPlatformCreditUsage
     * @request GET:/api/v1/platform/credits/usage
     * @response `200` `PlatformOrganizationCreditVo` OK
     */
    getPlatformCreditUsage: (params: RequestParams = {}) =>
      this.request<PlatformOrganizationCreditVo, any>({
        path: `/api/v1/platform/credits/usage`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name GetPlatformCreditTransaction
     * @request GET:/api/v1/platform/credits/transactions
     * @response `200` `ListResponseByPageUserCreditTransactionVo` OK
     */
    getPlatformCreditTransaction: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageUserCreditTransactionVo, any>({
        path: `/api/v1/platform/credits/transactions`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name GetPlatformCreditPackages
     * @request GET:/api/v1/platform/credits/packages
     * @response `200` `(PlatformCreditPackage)[]` OK
     */
    getPlatformCreditPackages: (params: RequestParams = {}) =>
      this.request<PlatformCreditPackage[], any>({
        path: `/api/v1/platform/credits/packages`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Platform
     * @name DeleteApiKey
     * @request DELETE:/api/v1/platform/api-keys/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteApiKey: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/platform/api-keys/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name GetSubscription
     * @request GET:/api/v1/notification/subscribe
     * @response `200` `SubscriptionView` OK
     */
    getSubscription: (params: RequestParams = {}) =>
      this.request<SubscriptionView, any>({
        path: `/api/v1/notification/subscribe`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name Subscribe
     * @request POST:/api/v1/notification/subscribe
     * @response `200` `SubscriptionView` OK
     */
    subscribe: (data: SubscribeRequest, params: RequestParams = {}) =>
      this.request<SubscriptionView, any>({
        path: `/api/v1/notification/subscribe`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name Unsubscribe
     * @request DELETE:/api/v1/notification/subscribe
     * @response `200` `IDOnlyResponse` OK
     */
    unsubscribe: (params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/notification/subscribe`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get the VAPID public key needed for web push subscription
     *
     * @tags Notification
     * @name GetVapidPublicKey
     * @summary Get VAPID public key
     * @request GET:/api/v1/notification/vapid-public-key
     * @response `200` `VapidPublicKeyView` OK
     */
    getVapidPublicKey: (params: RequestParams = {}) =>
      this.request<VapidPublicKeyView, any>({
        path: `/api/v1/notification/vapid-public-key`,
        method: "GET",
        ...params,
      }),
  };
  invitations = {
    /**
     * No description
     *
     * @tags Invitation
     * @name VerifyPermission
     * @request POST:/api/v1/invitations/verify
     * @response `200` `InvitationCodeResponse` OK
     */
    verifyPermission: (
      data: VerifyPermissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/verify`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name UseInvitationCode
     * @request POST:/api/v1/invitations/use
     * @response `200` `InvitationCodeResponse` OK
     */
    useInvitationCode: (
      data: UseInvitationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/use`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name UnbindInvitationCode
     * @request POST:/api/v1/invitations/unbind
     * @response `200` `InvitationCodeResponse` OK
     */
    unbindInvitationCode: (
      data: UnbindInvitationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/unbind`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name GenerateInvitationCode
     * @request POST:/api/v1/invitations/generate
     * @response `200` `InvitationCodeResponse` OK
     */
    generateInvitationCode: (
      data: GenerateInvitationCodeRequest[],
      params: RequestParams = {},
    ) =>
      this.request<InvitationCodeResponse, any>({
        path: `/api/v1/invitations/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  feedback = {
    /**
     * No description
     *
     * @tags Feedback
     * @name SubmitFeedback
     * @request POST:/api/v1/feedback
     * @response `200` `EmptySuccessResponse` OK
     */
    submitFeedback: (data: FeedbackSubmitRequest, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, any>({
        path: `/api/v1/feedback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  configs = {
    /**
     * No description
     *
     * @tags Config
     * @name SetConfig
     * @request POST:/api/v1/configs/set
     * @response `200` `ConfigResponse` OK
     */
    setConfig: (data: SetConfigRequest, params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/set`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Config
     * @name ListConfigs
     * @request POST:/api/v1/configs/list
     * @response `200` `ConfigResponse` OK
     */
    listConfigs: (params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/list`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Config
     * @name GetConfig
     * @request POST:/api/v1/configs/get
     * @response `200` `ConfigResponse` OK
     */
    getConfig: (data: GetConfigRequest, params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/get`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Config
     * @name DeleteConfig
     * @request POST:/api/v1/configs/delete
     * @response `200` `ConfigResponse` OK
     */
    deleteConfig: (data: DeleteConfigRequest, params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/configs/delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags Authorization
     * @name CheckAuth
     * @request POST:/api/v1/auth/check
     * @response `200` `CheckAuthVo` OK
     */
    checkAuth: (
      query: {
        authCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CheckAuthVo, any>({
        path: `/api/v1/auth/check`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GoogleLogin
     * @request GET:/auth/oauth2/google
     * @response `200` `void` OK
     */
    googleLogin: (
      query?: {
        invite_code?: string;
        function?: string;
        referral_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/google`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name DiscordLogin
     * @request GET:/auth/oauth2/discord
     * @response `200` `void` OK
     */
    discordLogin: (
      query?: {
        invite_code?: string;
        function?: string;
        referral_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/discord`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name BindDiscord
     * @request GET:/auth/oauth2/discord/bind
     * @response `200` `void` OK
     */
    bindDiscord: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/oauth2/discord/bind`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name BindDiscordCallback
     * @request GET:/auth/oauth2/discord/bind/callback
     * @response `200` `void` OK
     */
    bindDiscordCallback: (
      query?: {
        code?: string;
        error?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/discord/bind/callback`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GoogleCallback
     * @request GET:/auth/oauth2/callback/google
     * @response `200` `void` OK
     */
    googleCallback: (
      query?: {
        code?: string;
        error?: string;
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/callback/google`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name DiscordCallback
     * @request GET:/auth/oauth2/callback/discord
     * @response `200` `void` OK
     */
    discordCallback: (
      query?: {
        code?: string;
        error?: string;
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/oauth2/callback/discord`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name Logout
     * @request GET:/auth/logout
     * @response `200` `void` OK
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/logout`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name QueryUserAuth
     * @request GET:/api/v1/auth/user/get
     * @response `200` `AuthVo` OK
     */
    queryUserAuth: (params: RequestParams = {}) =>
      this.request<AuthVo, any>({
        path: `/api/v1/auth/user/get`,
        method: "GET",
        ...params,
      }),
  };
  assets = {
    /**
     * No description
     *
     * @tags Asset
     * @name ListAssets
     * @request GET:/api/v1/assets
     * @response `200` `ListResponseByPageAssetView` OK
     */
    listAssets: (
      query?: {
        /** @default [] */
        sources?: ListAssetsParamsSources[];
        /** @default [] */
        types?: ListAssetsParamsTypes[];
        /** @default "" */
        search?: string;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListResponseByPageAssetView, any>({
        path: `/api/v1/assets`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name UploadAsset
     * @request POST:/api/v1/assets
     * @response `200` `AssetView` OK
     */
    uploadAsset: (
      data: {
        /** @format binary */
        file: File;
      },
      query?: {
        /** @default "" */
        fileName?: string;
        /** @default "Upload" */
        source?: UploadAssetParamsSource;
        /** @default true */
        isArtifacts?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetView, any>({
        path: `/api/v1/assets`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name VideoModerationCallback
     * @request POST:/api/v1/assets/video-moderation-callback
     * @response `200` `IDOnlyResponse` OK
     */
    videoModerationCallback: (
      query: {
        request: ModerateVideoCallbackRequest;
      },
      params: RequestParams = {},
    ) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/assets/video-moderation-callback`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name MgetAssets
     * @request GET:/api/v1/assets/mget
     * @response `200` `Record<string,AssetView>` OK
     */
    mgetAssets: (
      query: {
        ids: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, AssetView>, any>({
        path: `/api/v1/assets/mget`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asset
     * @name DeleteAssetById
     * @request DELETE:/api/v1/assets/{id}
     * @response `200` `IDOnlyResponse` OK
     */
    deleteAssetById: (id: number, params: RequestParams = {}) =>
      this.request<IDOnlyResponse, any>({
        path: `/api/v1/assets/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  agent = {
    /**
     * No description
     *
     * @tags Agent Files
     * @name InitMultipartUpload
     * @request POST:/api/v1/agent/files/multipart-init
     * @response `200` `MultipartUploadVO` OK
     */
    initMultipartUpload: (
      data: MultipartUploadInitRequest,
      params: RequestParams = {},
    ) =>
      this.request<MultipartUploadVO, any>({
        path: `/api/v1/agent/files/multipart-init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent Files
     * @name CompleteMultipartUpload
     * @request POST:/api/v1/agent/files/multipart-complete
     * @response `200` `MultipartUploadVO` OK
     */
    completeMultipartUpload: (
      data: MultipartUploadCompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<MultipartUploadVO, any>({
        path: `/api/v1/agent/files/multipart-complete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Receive event callbacks from Agent
     *
     * @tags Agent Events
     * @name ReceiveEvent
     * @summary Receive agent event callback
     * @request POST:/api/v1/agent/events
     * @response `200` `Record<string,boolean>` OK
     */
    receiveEvent: (data: AgentEventRequest, params: RequestParams = {}) =>
      this.request<Record<string, boolean>, any>({
        path: `/api/v1/agent/events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent Usage
     * @name GetUsage
     * @request GET:/api/v1/agent/usages/get-usage
     * @response `200` `UserDailyUsageVO` OK
     */
    getUsage: (params: RequestParams = {}) =>
      this.request<UserDailyUsageVO, any>({
        path: `/api/v1/agent/usages/get-usage`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent Knowledge Base
     * @name ListKnowledgeBases
     * @request GET:/api/v1/agent/knowledge-bases
     * @response `200` `(SceneKnowledgeBaseDetail)[]` OK
     */
    listKnowledgeBases: (params: RequestParams = {}) =>
      this.request<SceneKnowledgeBaseDetail[], any>({
        path: `/api/v1/agent/knowledge-bases`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agent Config
     * @name GetAllowedDefaultModels
     * @request GET:/api/v1/agent/configs/allowed-default-models
     * @response `200` `Record<string,(object)[]>` OK
     */
    getAllowedDefaultModels: (params: RequestParams = {}) =>
      this.request<Record<string, object[]>, any>({
        path: `/api/v1/agent/configs/allowed-default-models`,
        method: "GET",
        ...params,
      }),
  };
  tmp = {
    /**
     * No description
     *
     * @tags Credit
     * @name RemoveRepeatExpireCredit
     * @request GET:/api/v1/tmp/fasfwlnegowirnbegorijgwe455/remove-repeat-repire-credit
     * @response `200` `void` OK
     */
    removeRepeatExpireCredit: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/tmp/fasfwlnegowirnbegorijgwe455/remove-repeat-repire-credit`,
        method: "GET",
        ...params,
      }),
  };
  system = {
    /**
     * No description
     *
     * @tags System
     * @name GetSystemConfig
     * @request GET:/api/v1/system/config
     * @response `200` `SystemConfigView` OK
     */
    getSystemConfig: (params: RequestParams = {}) =>
      this.request<SystemConfigView, any>({
        path: `/api/v1/system/config`,
        method: "GET",
        ...params,
      }),
  };
  promotions = {
    /**
     * No description
     *
     * @tags Promotion
     * @name GetActivePromotions
     * @summary Get all active promotions
     * @request GET:/api/v1/promotions/active
     * @response `200` `ActivePromotionVo` OK
     */
    getActivePromotions: (params: RequestParams = {}) =>
      this.request<ActivePromotionVo, any>({
        path: `/api/v1/promotions/active`,
        method: "GET",
        ...params,
      }),
  };
  discord = {
    /**
     * No description
     *
     * @tags Discord Integration
     * @name GetBindingStatus
     * @summary Get Discord binding status for current user
     * @request GET:/api/v1/discord/binding-status
     * @response `200` `DiscordBindingStatusVO` Binding status retrieved
     */
    getBindingStatus: (params: RequestParams = {}) =>
      this.request<DiscordBindingStatusVO, any>({
        path: `/api/v1/discord/binding-status`,
        method: "GET",
        ...params,
      }),
  };
  credits = {
    /**
     * No description
     *
     * @tags Credit
     * @name GetUserCredit
     * @request GET:/api/v1/credits/user
     * @response `200` `UserCreditVo` OK
     */
    getUserCredit: (params: RequestParams = {}) =>
      this.request<UserCreditVo, any>({
        path: `/api/v1/credits/user`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name GetUserCreditTransaction
     * @request GET:/api/v1/credits/transaction
     * @response `200` `UserCreditTransactionPageVo` OK
     */
    getUserCreditTransaction: (
      query: {
        /** @format int64 */
        continuationToken?: number;
        /** @format int32 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCreditTransactionPageVo, any>({
        path: `/api/v1/credits/transaction`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name GetUserAllCreditTransaction
     * @request GET:/api/v1/credits/transaction/by-user
     * @response `200` `UserCreditTransactionPageVo` OK
     */
    getUserAllCreditTransaction: (
      query?: {
        /**
         * @format int32
         * @default 1
         */
        pageNum?: number;
        /**
         * @format int32
         * @default 20
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCreditTransactionPageVo, any>({
        path: `/api/v1/credits/transaction/by-user`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name GetUserCreditTransactionByThread
     * @request GET:/api/v1/credits/transaction/by-thread
     * @response `200` `UserCreditTransactionPageVo` OK
     */
    getUserCreditTransactionByThread: (
      query: {
        threadId: string;
        /**
         * @format int32
         * @default 1
         */
        pageNum?: number;
        /**
         * @format int32
         * @default 20
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCreditTransactionPageVo, any>({
        path: `/api/v1/credits/transaction/by-thread`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name GetCredit
     * @request GET:/api/v1/credits/package
     * @response `200` `CreditPackagePageVo` OK
     */
    getCredit: (params: RequestParams = {}) =>
      this.request<CreditPackagePageVo, any>({
        path: `/api/v1/credits/package`,
        method: "GET",
        ...params,
      }),
  };
  coupons = {
    /**
     * No description
     *
     * @tags Coupon
     * @name GetEligibleCouponByCode
     * @request GET:/api/v1/coupons/query
     * @response `200` `CouponVo` OK
     */
    getEligibleCouponByCode: (
      query: {
        couponCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVo, any>({
        path: `/api/v1/coupons/query`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  activity = {
    /**
     * No description
     *
     * @tags Activity
     * @name GetMyActivities
     * @summary 获取用户参与的活动列表
     * @request GET:/api/v1/activity/my
     * @response `200` `(UserActivityVo)[]` OK
     */
    getMyActivities: (params: RequestParams = {}) =>
      this.request<UserActivityVo[], any>({
        path: `/api/v1/activity/my`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity
     * @name GetEligibleActivity
     * @summary 获取用户符合条件的活动
     * @request GET:/api/v1/activity/eligible
     * @response `200` `ActivityVo` OK
     */
    getEligibleActivity: (
      query?: {
        activityCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityVo, any>({
        path: `/api/v1/activity/eligible`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
}
